export enum LOGIN_STATUSES {
  WAIT_USER_EMAIL = 'WaitUserEmail',
  WAIT_EMAIL_VERIFICATION = 'WaitEmailVerification',
  ACCOUNT_MIGRATION_PASSWORD = 'AccountMigrationPassword',
  ACCOUNT_AGENT_INFO = 'AccountAgentInfo',
  FINISH_LOGIN = 'FinishLogin',
}
